import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiConfig from '../axiosConfig';

const initialState = {
    productsList: [],
    labels: [],
    merchants: [],
    categories: [],
    voucherTypes: [],
    status: null,
    error: null,
};

export const fetchAssets = createAsyncThunk(
    'giftSkuManagement/fetchAssets',
    async ({ id, inactive = false }) => {
        if (id == null) id = 'my';

        const response = await apiConfig
            .get(`product-management/list/${id}/${inactive ? '1' : '0'}`)
            .then((response) => response)
            .catch((error) => error);

        return response;
    }
);

export const toggelDeleteSku = createAsyncThunk('giftSkuManagement/toggelDelete', async (skuId) => {
    const response = await apiConfig.delete(`sku-management/delete/${skuId}`);
    const data = await response.data;
    return data;
});

export const deleteProduct = createAsyncThunk(
    'giftSkuManagement/deleteProduct',
    async ({ productId, flag }) => {
        const response = await apiConfig
            .delete(`product-management/${productId}/flags/${flag}`)
            .then((response) => response)
            .catch((error) => error);

        const data = (await response) && response.data ? response.data : response;
        return { ...data, productId };
    }
);

export const updateProduct = createAsyncThunk(
    'giftSkuManagement/updateProduct',
    async (payload) => {
        console.log("Updating New Product");

        let updatePayload = { ...payload };
        if (payload.image) {
            const imageUrls = await uploadImageProduct(updatePayload);
            if (imageUrls.data && imageUrls.data.data) {
                updatePayload = {
                    ...updatePayload,
                    imageUrl: imageUrls.data.data.csImageUlr,
                    imageUrlGcp: imageUrls.data.data.gcpImageUrl,
                };
            }
        }

        const response = await apiConfig
            .put(`product-management/${payload.id}`, { ...updatePayload })
            .then((response) => response)
            .catch((error) => error);

        const data = (await response) && response.data ? response.data : response;
        return {
            ...data,
            productId: payload.id,
            imageUrl: updatePayload.imageUrl,
            imageUrlGcp: updatePayload.imageUrlGcp,
        };
    }
);

export const addProduct = createAsyncThunk('giftSkuManagement/addProduct', async (payload) => {
    console.log("Adding New Product");
    let updatePayload = { ...payload };
    if (payload.image) {
        const imageUrls = await uploadImageProduct(updatePayload);
        if (imageUrls.data && imageUrls.data.data) {
            updatePayload = {
                ...updatePayload,
                imageUrl: imageUrls.data.data.csImageUlr,
                imageUrlGcp: imageUrls.data.data.gcpImageUrl,
            };
        }
    }
    const response = await apiConfig
        .post(`product-management`, { ...updatePayload })
        .then((response) => response)
        .catch((error) => error);

    const data = (await response) && response.data ? response.data : response;
    return { ...data };
});

export const uploadImageProduct = async (payload) => {
    const formData = new FormData();
    formData.append('file', payload.image, payload.image.name);
    return apiConfig
        .post(`product-management/upload`, formData)
        .then((response) => response)
        .catch((error) => error);
};

const giftSkuManagementSlice = createSlice({
    name: 'giftSkuManagement',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchAssets.pending]: (state) => {
            console.log('Pending');
            state.status = 'loading';
        },
        [fetchAssets.fulfilled]: (state, action) => {
            const response = action.payload.data;
            if (response?.status === 'OK') {
                state.productsList = [];
                state.status = 'OK';
                state.productsList = action.payload.data.data.sections.products;
                state.labels = action.payload.data.data.sections.labels;
                state.categories = action.payload.data.data.sections.categories;
                state.merchants = action.payload.data.data.sections.merchants;
                state.voucherTypes = action.payload.data.data.sections.voucherTypes || [];
            } else {
                state.status = 'failed';
                state.productsList = [];
                state.labels = [];
                state.categories = [];
                state.merchants = [];
                state.voucherTypes = [];
                state.error = action?.error?.message || action?.payload?.message;
            }
        },
        [fetchAssets.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.error.message;
        },
        [addProduct.fulfilled]: (state, action) => {
            const response = action.payload;
            console.log(response);
            if (response.status === 'CREATED') {
                const itemIndex = state.productsList.findIndex(
                    (item) => item.id === action.payload.data.id
                );
                if (itemIndex === -1) {
                    state.productsList = [...state.productsList, action.payload.data];
                } else {
                    state.productsList[itemIndex] = action.payload.data;
                }
            } else {
                state.status = 'failed';
                state.error = action.message;
            }
        },
        [toggelDeleteSku.fulfilled]: (state, action) => {
            const response = action.payload;

            if (response.status === 'OK') {
                const itemIndex = state.assets.findIndex(
                    (item) => item.id === action.payload.data.id
                );
                state.assets[itemIndex] = action.payload.data;
            } else {
                state.status = 'failed';
                state.error = action.error.message;
            }
        },
        [updateProduct.fulfilled]: (state, action) => {
            const response = action.payload;

            if (response.status === 'OK') {
                const itemIndex = state.productsList.findIndex(
                    (item) => item.id === response.productId
                );
                if (itemIndex !== -1) {
                    state.productsList[itemIndex] = { ...response.data };
                    if (response.imageUrl && response.imageUrlGcp) {
                        state.productsList[itemIndex].imageUrl = response.imageUrl;
                        state.productsList[itemIndex].imageUrlGcp = response.imageUrlGcp;
                    }
                }
            } else {
                state.status = 'failed';
                console.log(response)
                state.error = action.error.message;
            }
        },
        [deleteProduct.fulfilled]: (state, action) => {
            const response = action.payload;
            if (response.status === 'ACCEPTED') {
                const itemIndex = state.productsList.findIndex(
                    (item) => item.id === response.productId
                );
                if (itemIndex !== -1) {
                    switch (action.meta.arg.flag) {
                        case 'isDeleted':
                            state.productsList[itemIndex].isDeleted = !state.productsList[itemIndex].isDeleted;
                            break;
                        case 'isEarnPointsEnabled':
                            state.productsList[itemIndex].isEarnPointsEnabled = !state.productsList[itemIndex].isEarnPointsEnabled;
                            break;
                        case 'isBurnPointsEnabled':
                            state.productsList[itemIndex].isBurnPointsEnabled = !state.productsList[itemIndex].isBurnPointsEnabled;
                            break;
                    
                        default:
                            break;
                    }
                }
            } else {
                state.status = 'failed';
                state.error = action?.error?.message || '';
            }
        },
    },
});

export const assetManagementActions = giftSkuManagementSlice.actions;
export default giftSkuManagementSlice.reducer;